import styled from '@emotion/styled';
import {CSSProperties, FC, useEffect, useRef, useState} from 'react';
import {calculateCueBoxStyle} from '../../utils/vttUtils';
import {Cue as TCue} from '../subtitleContainer';
import {cueTextToHtml} from '../../utils/cueTextToHtml';
import {useParsedText} from '@backstage-components/base';

interface CueProps {
  cue: TCue;
  fontSize: string;
}

export const Cue: FC<CueProps> = ({cue: cueProp, fontSize}) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [styles, setStyles] = useState<CSSProperties>({});

  useEffect(() => {
    if (!cueProp.vtt || !ref.current) return;

    setStyles(calculateCueBoxStyle(cueProp.vtt, ref.current));
  }, [cueProp, ref]);

  return (
    <Container style={styles} ref={ref}>
      <span style={{fontSize}}>
        {useParsedText(cueTextToHtml(cueProp.text))}
      </span>
    </Container>
  );
};

const Container = styled.p`
  height: fit-content;
  text-shadow: -1px -1px 0 #000, 0 -1px 0 #000, 1px -1px 0 #000, -1px 0 0 #000,
    1px 0 0 #000, -1px 1px 0 #000, 0 1px 0 #000, 1px 1px 0 #000;
`;
